import { mapState } from 'vuex';
import BarCodeScanner from '../../components/util/BarCodeScanner'
import DistributionBarCodeScanner from '../../components/util/DistributionBarCodeScanner'
import distributionService from '../../services/DistributionService'
import i18n from '../../i18n/index'
import {
    StorageService
} from '../../services/StorageService'
import distributionLogService from '../../services/DistributionLogService'
import orderNewList from '../order-new-grid/OrderNewList.vue'
import XLSX from 'xlsx'

export default {
    components: {
        BarCodeScanner,
        DistributionBarCodeScanner,
        orderNewList
    },
    props: {
        distributionDetail: {
            type: Array,
            default: () => []
        },
        addNotificationFunction: {
            type: Function,
            default: () => { }
        },
        selectedDate: {
            type: String,
            default: () => ''
        },
        currentDistribution: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            search: '',
            headers: [{
                text: 'Nº',
                sortable: false,
                align: 'left'
            },
            {
                text: i18n.t('headers.patient-document'),
                sortable: false,
                align: 'left'
            },
            {
                text: i18n.t('headers.patient-name'),
                sortable: false,
                align: 'left'
            },
            {
                text: i18n.t('headers.nro-order'),
                sortable: false,
                value: 'number',
                align: 'left'
            },
            {
                text: i18n.t('headers.provider'),
                value: 'idProvider.name',
                sortable: false
            },
            {
                text: i18n.t('headers.total-documents'),
                value: 'totalDocuments',
                sortable: false
            },
            {
                text: i18n.t('headers.total-moderator-fee'),
                value: 'totalModeratorFee',
                sortable: false
            },
            {
                text: i18n.t('headers.shipping-date'),
                sortable: false,
                value: 'deliveryDate'
            },
            {
                text: i18n.t('headers.status'),
                sortable: false,
                value: 'status'
            },
            {
                text: i18n.t('headers.notification'),
                sortable: false,
                value: 'notification'
            }
            ],
            distributionItems: [],
            logsList: [],
            rowsPerPageItems: [5, 10, 15, 20],
            enableGenerateTemplateButton: false,
            orderProviderDocument: [],
            checkStatusSticker: '',
            dialog: false,
            barcodes: [],
            documentCount: 0,
            prueba: '104801-8-45685451',
            testBarcode: ''
        }
    },
    watch: {
        distributionDetail() {
            this.distributionItems = []
            this.orderProviderDocument = []
            let key = 1
            this.distributionDetail.forEach(items => {
                let item = {}
                item.DistributionMade = items.DistributionMade
                item.IsAppointment = items.IsAppointment
                item.attachment = items.attachment
                item.documentCount = items.documentCount
                item.fileName = items.fileName
                item.generationDate = items.generationDate
                item.id = items.id
                item.key = key.toString()
                item.idCity = items.idCity
                item.idProvider = items.idProvider
                item.initialProvider = items.initialProvider
                item.idProviderScheduleRange = items.idProviderScheduleRange
                item.notApplyShippingFee = items.notApplyShippingFee
                item.number = items.number
                item.observation = items.observation
                item.orderDetailBarCodes = items.orderDetailBarCodes
                item.orderDetails = items.orderDetails
                item.pendingOrders = items.pendingOrders
                item.shippingAddress = items.shippingAddress
                item.shippingDate = items.shippingDate
                item.shippingFee = items.shippingFee
                item.slidingScaleFee = items.slidingScaleFee
                item.status = items.status
                item.suborderBarCodes = items.suborderBarCodes
                item.type = items.type
                if (items.orderPatients.length === 1) {
                    items.orderPatients.forEach(patients => {
                        item.orderPatients = patients.idPatient.identification
                        item.names = patients.idPatient.name
                    })
                } else {
                    // eslint-disable-next-line one-var
                    let patients = '',
                        names = ''
                    items.orderPatients.forEach(p => {
                        let patient = p.idPatient.identification
                        let namePatient = p.idPatient.name
                        patients = patients.concat(patient + ' - ')
                        names = names.concat(namePatient + ' - ')
                    })
                    item.orderPatients = patients.trimRight(' - ')
                    item.names = names.trimRight(' - ')
                }
                this.distributionItems.push(item)
                key++
            })
            this.distributionItemsToShow = this.distributionItems
            // this.distributionItems = this.distributionDetail
            this.barcodes = []
            this.documentCount = 0
            this.getLogs()
        },
        currentDistribution() {
            this.enableGenerateTemplateButton =
                this.currentDistribution && this.distributionItems.length === 0
        }
    },

    computed: {
        ...mapState('auth', ['userInfo']),
    },

    methods: {
       async initScan() {
            window.addEventListener("keydown", (e) => {
                if (e.keyCode === 187) {
                    e.preventDefault();
                    return;
                }
            });
            this.dialog = true;
            //this.$barcodeScanner.init(this.onBarcodeScanned);
            this.getDistributionBarcode(true);
        },

        async getDistributionBarcode(init){
            let userId = StorageService.getUserData().id;
            const res = await distributionService.getDistributionBarcodes(userId); 
            const barcodes = res.data.barcodes;
            this.barcodes = barcodes;    
            this.documentCount = barcodes.length;     
            if(init){
                barcodes.map(data => {
                    const aux = {
                        idOrder: data.idOrder,
                        idProvider: data.providerId
                    }
                    this.orderProviderDocument.push(aux)
                })
            }
        },

        async saveDistributionBarcode(userId,barcode,providerId,idOrder){
            const res = await distributionService.saveDistributionBarcodes(userId,barcode,providerId,idOrder);
            if(res.status != 200){
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "error al guardar codigo",
                });
            }
        },
        async deleteDistributionBarcodes(){
            let userId = StorageService.getUserData().id;
            const res = await distributionService.deleteDistributionBarcodes(userId);
        },
        async onBarcodeScanned(barcode) {            
            
            if (barcode === "Enter") {
                return;
            }

            if (!this.barcodes.includes(barcode)) {
                this.handleBarCode(barcode);
                this.testBarcode = '';
            } else {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("scan-component.barcode-scanned-already"),
                });
            }
        },

        async emitBarcodes() {
            this.deleteDistributionBarcodes();
            this.$barcodeScanner.destroy();
            // this.$emit("barcodes", this.barcodes);
            // this.barcodes = [];
            // this.documentCount = 0;
            // this.counter = 0;
            this.dialog = false;
        },
        async getUserId() {
            let userId = await StorageService.getUserData().id;
            if (!userId || typeof userId === 'string') {
                if (this.userInfo) {
                    userId = this.userInfo.id
                }
                userId = 0
            }
            return userId
        },

        async handleBarCode(barCode) {
            this.checkStatusSticker = ''
            barCode = barCode.split("'").join('-')

            let userId = StorageService.getUserData().id;
            distributionService
                .sendCheckOut(barCode, userId, this.selectedDate)
                .then(response => {
                    if (response && response.data) {
                        const data = response.data
                        if (data === 'Interal server error.') {
                            this.$notify({
                                group: 'app',
                                type: 'error',
                                text: 'Código no válido'
                            })
                            return
                        }

                        if (data.code) {
                            if (data.code === 'WRONG_BAR_CODE') {
                                this.$notify({
                                    group: 'app',
                                    type: 'error',
                                    text: 'El número de pedido no existe'
                                })
                            }
                            return
                        }
                        switch (data.status) {
                            case 'OK':
                                this.dropSubOrderFromList(data, barCode,userId)
                                break
                            case 'DIFFERENT_DATE':
                                this.addLog(data.log)
                                this.$notify({
                                    group: 'app',
                                    type: 'error',
                                    text: i18n.t('distribution.suborder-different-date')
                                })
                                break
                            case 'ORDER_CANCELED':
                                this.addLog(data.log)
                                this.$notify({
                                    group: 'app',
                                    type: 'error',
                                    text: i18n.t('distribution.suborder-canceled')
                                })
                                break
                            default:
                                break
                        }
                    }
                })
                .catch(error => {
                    if (error && error.code) {
                        const errorCode = error.code

                        if (errorCode === 'USER_WITHOUT_BRANCH') {
                            this.$notify({
                                group: 'app',
                                type: 'error',
                                text: i18n.t('distribution.user-without-provider')
                            })
                        } else if (errorCode === 'WRONG_BAR_CODE') {
                            this.$notify({
                                group: 'app',
                                type: 'error',
                                text: i18n.t('distribution.wrong-bar-code')
                            })
                        }
                    }
                })
        },

        addLog(log) {
            log.idOrder.slidingScaleFee = log.idOrder.orderDetails
                .filter(od => od.idProvider.id === log.idProvider.id)
                .map(od => od.slidingScaleFee)
                .reduce((sum, ssf) => sum + ssf, 0)
            this.logsList.push(log)
        },

        async dropSubOrderFromList(data, barCode, userId) {                      
            const updateCount = data.updateCount
            const idOrder = data.order.id
            const idProvider = data.idProvider
            const suborderIndex = this.distributionItems.findIndex(
                so => {
                    return so.id === idOrder + '_' + idProvider
                }
            )
            if (suborderIndex >= 0 && updateCount >= 0) {
                this.distributionItems = this.distributionItems.filter(item => item.id !== (idOrder + '_' + idProvider))
                this.distributionItemsToShow = this.distributionItems
                this.$forceUpdate()
                // this.enableGenerateTemplateButton = this.distributionItems.length === 0
                this.enableGenerateTemplateButton = 1
                let aux = {}
                aux.idOrder = idOrder
                aux.idProvider = idProvider
                this.orderProviderDocument.push(aux)
                await this.saveDistributionBarcode(userId,barCode,idProvider,idOrder);  
                await this.getDistributionBarcode();              
                //this.barcodes.unshift(barCode)
                this.documentCount = this.barcodes.length
            }

            this.$notify({
                group: 'app',
                type: 'success',
                text: i18n.t('distribution.suborder-checked-out')
            })
        },

        getLogs() {
            const userData = StorageService.getUserData()

            this.logsList = []

            distributionLogService
                .getDistributionLogs(this.selectedDate, userData.providerId)
                .then(response => {
                    response.data.forEach(log => this.addLog(log))
                    this.$emit('logsList', this.logsList)
                })
        },
        generateDocument() {
            distributionService.gemerateDocument(this.selectedDate, this.orderProviderDocument).then(response => {
                this.orderProviderDocument.length = 0
                var columns = XLSX.utils.json_to_sheet(response.data)
                var wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, columns, 'Planilla')
                XLSX.writeFile(wb, `farmadomicilios_planilla_distribucion_${this.selectedDate
                    .split('-')
                    .join('')}.xlsx`)
            })
        }
    }
}
